import styled from 'styled-components';

export const Label = styled.p`
  margin: 10px 10px 20px 0px;
`;

export const TituloAcessoNegado = styled.h2`
  text-align: center;
  font-weight: 800;
  font-size: 25pt;
  color: var(--red-color-sefaz);
`;

export const FraseAcessoNegado = styled.p`
  margin: 0px;
  margin-bottom: ${props => props.marginBottom};
`;

export const ContainerRowAcessoNegado = styled.div`
  margin-top: 46px;
  display: flex;
  justify-content: center;

  svg {
    font-size: 40pt;
    margin-top: 0px;
    color: var(--red-color-sefaz);

    animation-name: tamanho;
    animation-duration: 4s;
    animation-iteration-count: infinite;

    @keyframes tamanho {
      0% {
        font-size: 30pt;
      }
      25% {
        font-size: 35pt;
      }
      50% {
        font-size: 30pt;
      }
      75% {
        font-size: 35pt;
      }
      100% {
        font-size: 30pt;
      }
    }
  }
`;
